import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { MypageContext, useMypageStore } from '../context';
import { MypageLoginLog } from '../components';
import { timeUtils } from '../../../common/utils/timeUtil';
import Pagination from '../../../components/pagination';
import { useLocation, Link } from 'react-router-dom';
import Seo from '../../../components/seo';

const LoginLog = observer(() => {
  const { mypageStore } = useMypageStore(MypageContext);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = parseInt(query.get('page')) || 1;
  const totalCount = mypageStore.data.total_cnt;

  useEffect(() => {
    const date = new Date();
    date.setMonth(date.getMonth() - 3);

    const startDt = timeUtils.dateFormatYmd(date);
    const endDt = timeUtils.dateFormatYmd(new Date());

    mypageStore.actionLoginLog({ startDt, endDt, page });
  }, [page]);

  return (
    <>
      <Seo title={'마이페이지 로그인기록'} />
      <div className="history_wrap login_log">
        <div className="list_area">
          <div className="tip_area">
            <p className="tx">※ 최대 3개월 이내의 내역만 확인 가능합니다.</p>
          </div>
          <MypageLoginLog items={mypageStore.data.list} />
          <Pagination page={page} totalCount={totalCount} rowCount={10} />
        </div>
      </div>
    </>
  );
});

export default LoginLog;
